export default "__VITE_ASSET__DqHcq$r2__"